export enum ReportState {
    None,
    Loading,
    Ready,
    Error
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/reports/dtos/enums/report-state.ts